import CommonTitle from "@/ui/common/bit/CommonTitle"
import SwiperOnMobile from "@/ui/SwiperOnMobile/SwiperOnMobile"
import styled from "@emotion/styled"
import { Autocomplete, Box, Paper, TextField, Typography } from "@mui/material"
import Link from "next/link"
import ButtonWithArrow from "ui/common/bit/ButtonWithArrow"
import BlockWrapper from "ui/common/BlockWrapper"
import { colors, mediaQueries, sizes } from "ui/theme/theme"

export const StyledBlockWrapper = styled(BlockWrapper)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const StyledContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: unset;
  gap: 25px;
  ${mediaQueries.desktopM} {
    gap: 28px;
  }
`

export const SearchContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: ${sizes.baseTriple};
  ${mediaQueries.desktopM} {
  }
`
export const StyledAutocomplete = styled(Autocomplete)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const StyledCommonTitle = styled(CommonTitle)`
  gap: ${sizes.baseTriple};
  text-align: center;
  .text {
    font-weight: 400;
    font-size: 17px;
  }
`

export const StyledTextField = styled(TextField)`
  width: 100%;
  max-width: 388px;
  background-color: ${colors.white};
  border-radius: ${sizes.borderRadiusLarge};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  & .MuiOutlinedInput-root {
    border-radius: 24px;
    align-items: center;
  }
  & .MuiInputAdornment-root {
    color: ${colors.black};
    margin: 0;
  }
  & .MuiOutlinedInput-input {
    padding: 16px 20px;
    font-size: 16px;
    border: none;
    &::placeholder {
      opacity: 0.7;
    }
  }
  & .MuiPaper-root {
    background-color: pink;
    padding: 0;
  }
`

// Custom styles for Autocomplete dropdown paper - converted to proper styled component
export const AutocompletePaper = styled(Paper)`
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: ${sizes.borderRadiusLarge};
  margin-top: 4px;
  background-color: ${colors.white};
  & .MuiAutocomplete-option {
    padding: 12px 16px;
    font-size: 14px;
    transition: background-color 0.2s ease;
    &[data-focus="true"] {
      background-color: ${colors.blue};
    }
    &:hover {
      background-color: ${colors.blue};
    }
  }
  & .MuiAutocomplete-noOptions {
    padding: 12px 16px;
    font-size: 14px;
    color: ${colors.gray};
  }
  & .MuiAutocomplete-loading {
    padding: 12px 16px;
    font-size: 14px;
    color: ${colors.gray};
  }
`

// Keep the object version for backward compatibility and transition
export const StyledAutocompletePaper = {
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  borderRadius: sizes.borderRadiusLarge,
  marginTop: "4px",
  backgroundColor: colors.white,
  "& .MuiAutocomplete-option": {
    padding: "12px 16px",
    fontSize: "14px",
    transition: "background-color 0.2s ease",
    '&[data-focus="true"]': {
      backgroundColor: colors.blue,
    },
    "&:hover": {
      backgroundColor: colors.blue,
    },
  },
  "& .MuiAutocomplete-noOptions": {
    padding: "12px 16px",
    fontSize: "14px",
    color: colors.gray,
  },
  "& .MuiAutocomplete-loading": {
    padding: "12px 16px",
    fontSize: "14px",
    color: colors.gray,
  },
}

export const StyledOptionLink = styled(Link)`
  width: 100%;
  text-decoration: none;
  color: ${colors.black};
  display: block;
  padding: 6px 0;
`

export const SearchIconWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`

export const ResultsCount = styled(Typography)`
  text-align: center;
  margin-top: ${sizes.baseSingle};
  color: ${colors.gray};
  font-size: 14px;
`

export const CardsListWrapper = styled(SwiperOnMobile)`
  gap: 40px;
`

export const IconWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: ${sizes.baseSingle};
  ${mediaQueries.tabletDown} {
    padding: 0;
  }
  ${mediaQueries.desktopXl} {
    padding-bottom: ${sizes.baseDouble};
  }
`

export const IconCard = styled(ButtonWithArrow)`
  &.MuiButtonBase-root {
    backdrop-filter: blur(10px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: ${sizes.radius.medium};
    background-color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-size: 16px;
    width: 126px;
    height: 126px;
    transition:
      transform 0.3s ease,
      box-shadow 0.3s ease;
    &:hover,
    &:focus,
    &.active {
      background-color: ${colors.white};
      transform: translateY(-5px);
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    }
    svg {
      display: none;
    }
  }
`

export const CardTitle = styled(Typography)<{ component?: string }>`
  display: flex;
  color: ${colors.black};
  font-weight: 700;
  text-align: center;
  font-size: 16px;
  line-height: 19px;
  align-items: center;
  ${mediaQueries.desktopM} {
    font-size: 14px;
  }
  ${mediaQueries.desktopXl} {
    font-size: 16px;
  }
`

export const NoResultsMessage = styled(Typography)`
  text-align: center;
  margin-top: ${sizes.baseDouble};
  color: ${colors.gray};
  font-size: 16px;
`
